import { render, staticRenderFns } from "./UnAuth.vue?vue&type=template&id=36be46a2&scoped=true&"
import script from "./UnAuth.vue?vue&type=script&lang=js&"
export * from "./UnAuth.vue?vue&type=script&lang=js&"
import style0 from "./UnAuth.vue?vue&type=style&index=0&id=36be46a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be46a2",
  null
  
)

export default component.exports